// GaonSeHome.jsx
import React, { useState, useMemo } from "react";
import { useSelector } from 'react-redux';
import { useNavigate, Link } from "react-router-dom";

export default function GaonSeHome() {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();

  const tabs = [
    "Gaon ke Products",
    "My Orders",
    "My Referral Income",
    "My Resells",
    "Community Order",
    "My Contract Order",
    "Rural Digital Boutiques",
  ];

  const [activeTab, setActiveTab] = useState(tabs[0]);

  // --- Dummy product catalogue ---
  const dummyProducts = [
    {
      id: "P001",
      title: "Organic Millet Flour (Bajra)",
      category: "Agri",
      seller: "SHG - Asha Women",
      price: 180,
      mrp: 220,
      unit: "1 kg",
      img: "https://via.placeholder.com/400x300?text=Bajra+Flour",
      tags: ["Women", "Dadi Ma"],
      etdDays: 3,
      sellerPhone: "+91-98765-43210",
      sellerChatId: "seller123",
    },
    {
      id: "P002",
      title: "Handloom Cotton Saree",
      category: "Tribal",
      seller: "Bastar Artisans",
      price: 1200,
      mrp: 1500,
      unit: "piece",
      img: "https://via.placeholder.com/400x300?text=Handloom+Saree",
      tags: ["Tribal", "Women"],
      etdDays: 7,
      sellerPhone: "+91-91234-56789",
      sellerChatId: "artisan456",
    },
    {
      id: "P003",
      title: "Farm Fresh A2 Cow Ghee",
      category: "Dairy",
      seller: "Gaon Dairy Co-op",
      price: 550,
      mrp: 650,
      unit: "500 g",
      img: "https://via.placeholder.com/400x300?text=A2+Ghee",
      tags: ["Agri", "Dadi Ma"],
      etdDays: 2,
      sellerPhone: "+91-99887-76543",
      sellerChatId: "dairy789",
    },
    {
      id: "P004",
      title: "Free Range Eggs (12 pcs)",
      category: "Poultry",
      seller: "Kisan Poultry",
      price: 120,
      mrp: 150,
      unit: "12 pcs",
      img: "https://via.placeholder.com/400x300?text=Eggs",
      tags: ["Agri"],
      etdDays: 1,
      sellerPhone: "+91-97654-32109",
      sellerChatId: "poultry101",
    },
    {
      id: "P005",
      title: "Fresh Rohu (1 kg)",
      category: "Fisheries",
      seller: "River Catch",
      price: 240,
      mrp: 300,
      unit: "1 kg",
      img: "https://via.placeholder.com/400x300?text=Rohu",
      tags: ["Agri"],
      etdDays: 2,
      sellerPhone: "+91-96543-21098",
      sellerChatId: "fish202",
    },
    {
      id: "P006",
      title: "Handmade Clay Idli Set",
      category: "Tribal",
      seller: "Village Crafts",
      price: 450,
      mrp: 600,
      unit: "set",
      img: "https://via.placeholder.com/400x300?text=Clay+Idli+Set",
      tags: ["Tribal", "Women"],
      etdDays: 6,
      sellerPhone: "+91-95432-10987",
      sellerChatId: "crafts303",
    },
    {
      id: "P007",
      title: "Seasonal Mixed Vegetables Box",
      category: "Agri",
      seller: "Local Farmers Collective",
      price: 220,
      mrp: 300,
      unit: "5 kg",
      img: "https://via.placeholder.com/400x300?text=Veg+Box",
      tags: ["Agri"],
      etdDays: 1,
      sellerPhone: "+91-94321-09876",
      sellerChatId: "farmers404",
    },
    // add more items to simulate a big catalogue
  ];

  const categories = [
    "All",
    "Women",
    "Agri",
    "Poultry",
    "Fisheries",
    "Dairy",
    "Tribal",
    "Dadi Ma",
  ];

  // --- Orders dummy data ---
  const ordersDummy = {
    customer: [
      { id: "O1001", product: "Organic Millet Flour (Bajra)", status: "Delivered", amount: 180, date: "2025-10-28" },
      { id: "O1002", product: "Free Range Eggs (12 pcs)", status: "Out for Delivery", amount: 120, date: "2025-11-02" },
    ],
    seller: [
      { id: "S2001", product: "Handloom Cotton Saree", buyer: "Priya K.", status: "Shipped", amount: 1200, date: "2025-11-01" },
    ],
    coordinator: [
      { id: "C3001", task: "Cataloging - Village X", status: "Pending", assignedTo: "Digital Saathi - Meena" },
    ],
  };

  // --- Referral / MLM dummy ---
  const referrals = [
    { id: "R1", name: "Asha", level: 1, orders: 5, income: 150 },
    { id: "R2", name: "Sunita", level: 2, orders: 3, income: 90 },
    { id: "R3", name: "Ramesh", level: 1, orders: 2, income: 60 },
  ];

  // --- Resells dummy ---
  const resells = [
    { id: "RS1", title: "Curated Handloom Box", source: "GaonSe Curator", price: 2500, stock: 6 },
  ];

  // --- Community Orders dummy ---
  const communityOrders = [
    { id: "U100", product: "Organic Millet Flour (Bajra)", qty: 50, discountPercent: 12, etdDays: 5 },
  ];

  // --- Coordinators dummy ---
  const boutiques = [
    { id: "B1", name: "Digital Saathi - Meena", village: "Rampur", handled: 120, phone: "+91-98765-43210" },
    { id: "B2", name: "Boutique - Suman", village: "Bastar", handled: 80, phone: "+91-91234-56789" },
  ];

  // UI states for product page
  const [search, setSearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [sortBy, setSortBy] = useState("relevance");
  const [cart, setCart] = useState([]); // Array of {product, quantity}
  const [showUnityModal, setShowUnityModal] = useState(false);
  const [unityProduct, setUnityProduct] = useState(null);
  const [unityQty, setUnityQty] = useState(10);
  const [showCartModal, setShowCartModal] = useState(false);
  const [showCheckoutModal, setShowCheckoutModal] = useState(false);
  const [address, setAddress] = useState("");
  const [paymentMode, setPaymentMode] = useState("COD");
  const [upiId, setUpiId] = useState("");

  const filteredProducts = useMemo(() => {
    let list = [...dummyProducts];
    if (selectedCategory !== "All") {
      // filter by category or tags
      list = list.filter(
        (p) => p.category === selectedCategory || (p.tags && p.tags.includes(selectedCategory))
      );
    }
    if (search.trim()) {
      const s = search.trim().toLowerCase();
      list = list.filter(
        (p) => p.title.toLowerCase().includes(s) || p.seller.toLowerCase().includes(s)
      );
    }
    if (sortBy === "price-asc") list.sort((a, b) => a.price - b.price);
    if (sortBy === "price-desc") list.sort((a, b) => b.price - a.price);
    return list;
  }, [dummyProducts, selectedCategory, search, sortBy]);

  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
  const subtotal = cart.reduce((sum, item) => sum + (item.product.price * item.quantity), 0);

  function addToCart(product) {
    setCart((prev) => {
      const existing = prev.find((item) => item.product.id === product.id);
      if (existing) {
        return prev.map((item) =>
          item.product.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...prev, { product, quantity: 1 }];
    });
    // alert(`Added ${product.title} to cart (dummy) - integrate backend later`);
  }

  function updateCartQuantity(productId, newQty) {
    if (newQty <= 0) {
      removeFromCart(productId);
      return;
    }
    setCart((prev) =>
      prev.map((item) =>
        item.product.id === productId
          ? { ...item, quantity: newQty }
          : item
      )
    );
  }

  function removeFromCart(productId) {
    setCart((prev) => prev.filter((item) => item.product.id !== productId));
  }

  function clearCart() {
    setCart([]);
  }

  function proceedToCheckout() {
    if (cart.length === 0) {
      alert("Cart is empty!");
      return;
    }
    setShowCartModal(false);
    setShowCheckoutModal(true);
  }

  function placeOrder() {
    if (!address.trim()) {
      alert("Please enter delivery address!");
      return;
    }
    if (paymentMode === "UPI" && !upiId.trim()) {
      alert("Please enter UPI ID!");
      return;
    }
    // Dummy order placement
    alert(
      `Order placed successfully!\nTotal: ₹${subtotal}\nPayment: ${paymentMode}${paymentMode === "UPI" ? ` via ${upiId}` : ""}\nDelivery Address: ${address}\n(dummy - integrate backend later)`
    );
    clearCart();
    setShowCheckoutModal(false);
    setActiveTab("My Orders"); // Switch to orders tab
  }

  function openUnity(product) {
    setUnityProduct(product);
    setUnityQty(10);
    setShowUnityModal(true);
  }

  function placeUnityOrder() {
    // show confirmation - backend integration later
    alert(
      `Unity Order placed for ${unityQty} x ${unityProduct.title}. Estimated delivery in ${unityProduct.etdDays + 2} days. (Dummy)`
    );
    setShowUnityModal(false);
  }

  function talkToSeller(product) {
    // Dummy implementation
    alert(`Calling ${product.seller} at ${product.sellerPhone}... (Dummy - integrate call API later)`);
  }

  function chatWithSeller(product) {
    // Dummy implementation
    alert(`Opening chat with ${product.seller} (ID: ${product.sellerChatId})... (Dummy - integrate chat service later)`);
  }

  function digitalTwin(product) {
    // Navigate to /dtwin
    navigate("/dtwin", { state: { product } });
  }

  function askAI(product) {
    // Dummy implementation
    alert(`AI Response: "${product.title}" is a premium organic product from ${product.seller}, rich in nutrients and ethically sourced. (Dummy AI integration later)`);
  }

  function feedback(product) {
    // Dummy implementation
    const rating = prompt(`Rate ${product.title} (1-5):`, "5");
    if (rating) {
      alert(`Thank you! You rated ${product.title} ${rating}/5. (Dummy - integrate feedback API later)`);
    }
  }

  // --- small components inside file for clarity ---
  const TabHeaders = () => (
    <div className="w-full grid grid-cols-3 lg:grid-cols-5 gap-0 py-1 px-1">
      {tabs.map((t) => (
        <button
          key={t}
          className={`px-3 py-2 rounded-lg text-sm font-medium transition-all ${
            t === activeTab ? "bg-amber-500 text-gray-900" : "bg-gray-800 text-gray-200"
          }`}
          onClick={() => setActiveTab(t)}
        >
          {t}
        </button>
      ))}
      <button
        className="px-3 py-2 rounded-lg text-sm font-medium bg-green-600 text-white hover:bg-green-700 flex items-center justify-center"
        onClick={() => navigate("/agrilink-metaverse")}
        >
        🌐 <span>Metaverse</span>
      </button>
    </div>
  );

  const ProductCard = ({ product }) => (
    <div className="bg-gray-900 rounded-xl p-3 shadow-md w-full">
      <div className="flex gap-3">
        <img src={product.img} alt={product.title} className="w-28 h-20 rounded object-cover" />
        <div className="flex-1">
          <h3 className="text-sm font-semibold">{product.title}</h3>
          <p className="text-xs text-gray-400">{product.seller} • {product.unit}</p>
          <div className="mt-2 flex items-center justify-between">
            <div>
              <div className="text-sm font-bold">₹{product.price}</div>
              <div className="text-xs line-through text-gray-600">₹{product.mrp}</div>
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-0">
  {/* Add to Cart */}
  <button
    className="flex items-center justify-center gap-1 px-3 py-1.5 border border-amber-500 text-amber-400 text-xs rounded-md hover:bg-amber-500 hover:text-gray-900 transition-all"
    onClick={() => addToCart(product)}
  >
    <i className="fa-solid fa-cart-plus text-[0.7rem]" /> Add
  </button>

  {/* Unity / Community Order */}
  <button
    className="flex items-center justify-center w-28 gap-1 px-3 py-1.5 bg-amber-500 text-gray-900 border border-amber-500 text-xs rounded-md hover:bg-amber-600 transition-all"
    onClick={() => openUnity(product)}
  >
    <i className="fa fa-users text-[0.7rem]"></i> Unity  </button>

  {/* Talk to Seller */}
  <button
    className="flex items-center justify-center gap-1 px-3 py-1.5 border border-green-500 text-green-400 text-xs rounded-md hover:bg-green-500 hover:text-gray-900 transition-all"
    onClick={() => talkToSeller(product)}
  >
    <i className="fa-solid fa-phone text-[0.7rem]" /> Talk
  </button>

  {/* Chat with Seller */}
  <button
    className="flex items-center justify-center gap-1 px-3 py-1.5 border border-blue-500 text-blue-400 text-xs rounded-md hover:bg-blue-500 hover:text-gray-900 transition-all"
    onClick={() => chatWithSeller(product)}
  >
    <i className="fa-solid fa-comments text-[0.7rem]" /> Chat
  </button>

  {/* Digital Twin */}
  <button
    className="flex items-center justify-center gap-1 px-3 py-1.5 border border-purple-500 text-purple-400 text-xs rounded-md hover:bg-purple-500 hover:text-gray-900 transition-all"
    onClick={() => digitalTwin(product)}
  >
    <i className="fa-solid fa-robot text-[0.7rem]" /> DTwin
  </button>

  {/* Ask AI */}
  <button
    className="flex items-center justify-center gap-1 px-3 py-1.5 border border-indigo-500 text-indigo-400 text-xs rounded-md hover:bg-indigo-500 hover:text-gray-900 transition-all"
    onClick={() => askAI(product)}
  >
    <i className="fa-solid fa-brain text-[0.7rem]" /> AI
  </button>

  {/* Feedback / Rating */}
  <button
    className="flex items-center justify-center gap-1 px-3 py-1.5 border border-yellow-500 text-yellow-400 text-xs rounded-md hover:bg-yellow-500 hover:text-gray-900 transition-all"
    onClick={() => feedback(product)}
  >
    <i className="fa-solid fa-star text-[0.7rem]" /> Rate
  </button>
</div>

          </div>
          <div className="mt-2 text-xs text-gray-400">ETD: {product.etdDays} days</div>
        </div>
      </div>
    </div>
  );

  const CartItem = ({ item }) => (
    <div className="flex gap-3 py-2 border-b border-gray-800">
      <img src={item.product.img} alt={item.product.title} className="w-16 h-12 rounded object-cover" />
      <div className="flex-1">
        <h4 className="text-sm font-medium">{item.product.title}</h4>
        <p className="text-xs text-gray-400">{item.product.seller}</p>
        <div className="mt-1 flex items-center justify-between">
          <div className="font-semibold">₹{item.product.price}</div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => updateCartQuantity(item.product.id, item.quantity - 1)}
              className="px-2 py-1 text-xs bg-gray-800 rounded"
            >
              -
            </button>
            <span className="w-8 text-center text-sm">{item.quantity}</span>
            <button
              onClick={() => updateCartQuantity(item.product.id, item.quantity + 1)}
              className="px-2 py-1 text-xs bg-gray-800 rounded"
            >
              +
            </button>
          </div>
        </div>
      </div>
      <button
        onClick={() => removeFromCart(item.product.id)}
        className="text-red-400 text-sm"
      >
        Remove
      </button>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-950 text-gray-100 p-3 sm:p-6">
      <header className="mb-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-lg font-bold">GaonSe</h1>
            <p className="text-xs text-gray-400">From the village to your home</p>
          </div>
          <div className="flex items-center gap-3">
            <div className="text-right text-xs">
              <div>Hi, {authState.user.name}</div>
              <div className="text-gray-500">Member ID: {authState.user.think5whyscode}</div>
            </div>
            <div className="relative">
              <button
                onClick={() => setShowCartModal(true)}
                className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center relative"
              >
                <i className="fa fa-shopping-cart" />
                {totalItems > 0 && (
                  <span className="absolute -top-1 -right-1 bg-red-500 text-xs rounded-full w-5 h-5 flex items-center justify-center">
                    {totalItems}
                  </span>
                )}
              </button>
            </div>
            <div className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center">
              <i className="fa fa-user" />
            </div>
          </div>
        </div>

        <div className="mt-3">
          <TabHeaders />
        </div>
      </header>

      <main>
        {activeTab === "Gaon ke Products" && (
          <section>
            {/* Search and Filters */}
            <div className="flex gap-2 flex-col sm:flex-row items-stretch mb-3">
              <div className="flex-1">
                <div className="relative">
                  <input
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search products, sellers..."
                    className="w-full py-3 pl-10 pr-3 rounded-lg bg-gray-800 text-sm text-gray-100"
                  />
                  <i className="fa fa-search absolute left-3 top-3 text-gray-400" />
                </div>
              </div>
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="w-48 h-10 py-3 rounded-lg bg-gray-800 text-sm"
              >
                {categories.map((c) => (
                  <option value={c} key={c}>
                    {c}
                  </option>
                ))}
              </select>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="w-44 h-10 py-3 rounded-lg bg-gray-800 text-sm"
              >
                <option value="relevance">Sort: Relevance</option>
                <option value="price-asc">Price: Low to High</option>
                <option value="price-desc">Price: High to Low</option>
              </select>
            </div>

            {/* Product grid */}
            <div className="grid grid-cols-1 gap-3">
              {filteredProducts.map((p) => (
                <ProductCard key={p.id} product={p} />
              ))}
              {filteredProducts.length === 0 && (
                <div className="text-center text-gray-400 py-8">No products found.</div>
              )}
            </div>

            {/* Payment options area (dummy) */}
            <div className="mt-6 bg-gray-900 rounded-xl p-3">
              <h4 className="text-sm font-semibold mb-2">Payment modes (demo)</h4>
              <div className="flex gap-2 text-xs">
                <div className="flex-1 p-3 rounded border border-gray-800 text-center">Cash on Delivery (COD)</div>
                <div className="flex-1 p-3 rounded border border-gray-800 text-center">UPI</div>
              </div>
            </div>
          </section>
        )}

        {activeTab === "My Orders" && (
          <section className="space-y-3">
            <div className="flex gap-2 overflow-auto">
              <button className="px-3 py-2 rounded bg-amber-500 text-gray-900">Customer</button>
              <button className="px-3 py-2 rounded bg-gray-800">Seller</button>
              <button className="px-3 py-2 rounded bg-gray-800">Digital Co-ordinators</button>
            </div>

            <div className="bg-gray-900 rounded-xl p-3">
              <h4 className="text-sm font-semibold mb-2">Customer Orders</h4>
              {ordersDummy.customer.map((o) => (
                <div key={o.id} className="flex justify-between items-center py-2 border-b border-gray-800 text-sm">
                  <div>
                    <div className="font-medium">{o.product}</div>
                    <div className="text-xs text-gray-400">Order: {o.id} • {o.date}</div>
                  </div>
                  <div className="text-right">
                    <div className="font-semibold">₹{o.amount}</div>
                    <div className="text-xs text-amber-400">{o.status}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-gray-900 rounded-xl p-3">
              <h4 className="text-sm font-semibold mb-2">Seller Orders</h4>
              {ordersDummy.seller.map((o) => (
                <div key={o.id} className="flex justify-between items-center py-2 border-b border-gray-800 text-sm">
                  <div>
                    <div className="font-medium">{o.product}</div>
                    <div className="text-xs text-gray-400">Buyer: {o.buyer} • {o.date}</div>
                  </div>
                  <div className="text-right">
                    <div className="font-semibold">₹{o.amount}</div>
                    <div className="text-xs text-amber-400">{o.status}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-gray-900 rounded-xl p-3">
              <h4 className="text-sm font-semibold mb-2">Coordinator Tasks</h4>
              {ordersDummy.coordinator.map((o) => (
                <div key={o.id} className="flex justify-between items-center py-2 border-b border-gray-800 text-sm">
                  <div>
                    <div className="font-medium">{o.task}</div>
                    <div className="text-xs text-gray-400">Assigned: {o.assignedTo}</div>
                  </div>
                  <div className="text-xs text-amber-400">{o.status}</div>
                </div>
              ))}
            </div>

          </section>
        )}

        {activeTab === "My Referral Income" && (
          <section>
            <div className="bg-gray-900 rounded-xl p-3">
              <h4 className="text-sm font-semibold">Referral / MLM Income (demo)</h4>
              <div className="mt-2 text-xs text-gray-400">Your direct referrals and commissions</div>
              <div className="mt-3 space-y-2">
                {referrals.map((r) => (
                  <div key={r.id} className="flex justify-between items-center py-2 border-b border-gray-800 text-sm">
                    <div>
                      <div className="font-medium">{r.name} (Level {r.level})</div>
                      <div className="text-xs text-gray-400">Orders: {r.orders}</div>
                    </div>
                    <div className="text-right">
                      <div className="font-semibold">₹{r.income}</div>
                      <div className="text-xs text-amber-400">Paid</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        {activeTab === "My Resells" && (
          <section>
            <div className="grid grid-cols-1 gap-3">
              {resells.map((r) => (
                <div key={r.id} className="bg-gray-900 rounded-xl p-3">
                  <div className="flex justify-between items-center">
                    <div>
                      <div className="font-semibold">{r.title}</div>
                      <div className="text-xs text-gray-400">From: {r.source}</div>
                    </div>
                    <div className="text-right">
                      <div className="font-bold">₹{r.price}</div>
                      <div className="text-xs text-gray-400">Stock: {r.stock}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {activeTab === "Community Order" && (
          <section>
            <div className="bg-gray-900 rounded-xl p-3">
              <h4 className="text-sm font-semibold">Active Community Orders</h4>
              <div className="mt-2 space-y-2">
                {communityOrders.map((c) => (
                  <div key={c.id} className="flex justify-between items-center py-2 border-b border-gray-800">
                    <div>
                      <div className="font-medium">{c.product}</div>
                      <div className="text-xs text-gray-400">Qty required: {c.qty}</div>
                    </div>
                    <div className="text-right">
                      <div className="font-semibold">Discount: {c.discountPercent}%</div>
                      <div className="text-xs">ETD: {c.etdDays} days</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-4 text-center">
                <button className="px-4 py-2 rounded bg-amber-500 text-gray-900" onClick={() => alert('Community order flow - integrate later')}>
                  Join Community Order
                </button>
              </div>
            </div>
          </section>
        )}

        {activeTab === "Rural Digital Boutiques" && (
          <section>
            <div className="grid grid-cols-1 gap-3">
              {boutiques.map((b) => (
                <div key={b.id} className="bg-gray-900 rounded-xl p-3 flex justify-between items-center">
                  <div>
                    <div className="font-semibold">{b.name}</div>
                    <div className="text-xs text-gray-400">{b.village} • Handled: {b.handled}</div>
                    <div className="text-xs text-gray-400">{b.phone}</div>
                  </div>
                  <div className="flex flex-col gap-2">
                    <button className="px-3 py-1 rounded border border-amber-500 text-amber-400 text-xs">Catalog</button>
                    <button className="px-3 py-1 rounded bg-amber-500 text-gray-900 text-xs">Contact</button>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

      </main>

      {/* CART MODAL */}
      {showCartModal && (
        <div className="fixed inset-0 bg-black/60 flex items-end sm:items-center justify-center p-4 z-50">
          <div className="w-full max-w-md bg-gray-900 rounded-xl p-4 max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Your Cart ({totalItems} items)</h3>
              <button onClick={() => setShowCartModal(false)} className="text-gray-400 text-xl">✕</button>
            </div>
            {cart.length === 0 ? (
              <div className="text-center text-gray-400 py-8">Your cart is empty.</div>
            ) : (
              <>
                <div className="space-y-2">
                  {cart.map((item) => (
                    <CartItem key={item.product.id} item={item} />
                  ))}
                </div>
                <div className="mt-4 pt-4 border-t border-gray-800">
                  <div className="flex justify-between text-sm">
                    <span>Subtotal:</span>
                    <span className="font-semibold">₹{subtotal}</span>
                  </div>
                  <button
                    onClick={proceedToCheckout}
                    className="w-full mt-3 py-2 rounded bg-amber-500 text-gray-900 font-semibold"
                  >
                    Proceed to Checkout
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* CHECKOUT MODAL */}
      {showCheckoutModal && (
        <div className="fixed inset-0 bg-black/60 flex items-end sm:items-center justify-center p-4 z-50">
          <div className="w-full max-w-md bg-gray-900 rounded-xl p-4 max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Checkout</h3>
              <button onClick={() => setShowCheckoutModal(false)} className="text-gray-400 text-xl">✕</button>
            </div>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">Delivery Address</label>
                <textarea
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  placeholder="Enter your full address..."
                  className="w-full p-2 rounded bg-gray-800 text-sm"
                  rows={3}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Payment Method</label>
                <div className="space-y-2">
                  <label className="flex items-center">
                    <input
                      type="radio"
                      value="COD"
                      checked={paymentMode === "COD"}
                      onChange={(e) => setPaymentMode(e.target.value)}
                      className="mr-2"
                    />
                    Cash on Delivery (COD)
                  </label>
                  <label className="flex items-center">
                    <input
                      type="radio"
                      value="UPI"
                      checked={paymentMode === "UPI"}
                      onChange={(e) => setPaymentMode(e.target.value)}
                      className="mr-2"
                    />
                    UPI
                  </label>
                </div>
                {paymentMode === "UPI" && (
                  <div className="mt-2">
                    <input
                      type="text"
                      value={upiId}
                      onChange={(e) => setUpiId(e.target.value)}
                      placeholder="Enter UPI ID (e.g., user@paytm)"
                      className="w-full p-2 rounded bg-gray-800 text-sm"
                    />
                  </div>
                )}
              </div>
              <div className="text-sm">
                <div className="flex justify-between">
                  <span>Total Amount:</span>
                  <span className="font-semibold">₹{subtotal}</span>
                </div>
              </div>
              <button
                onClick={placeOrder}
                className="w-full py-2 rounded bg-amber-500 text-gray-900 font-semibold"
              >
                Place Order
              </button>
            </div>
          </div>
        </div>
      )}

      {/* UNITY MODAL */}
      {showUnityModal && unityProduct && (
        <div className="fixed inset-0 bg-black/60 flex items-end sm:items-center justify-center p-4">
          <div className="w-full max-w-md bg-gray-900 rounded-xl p-4">
            <div className="flex justify-between items-center">
              <div>
                <h3 className="font-semibold">Place Unity Order</h3>
                <div className="text-xs text-gray-400">{unityProduct.title}</div>
              </div>
              <button className="text-gray-400 text-xl" onClick={() => setShowUnityModal(false)}>✕</button>
            </div>

            <div className="mt-3">
              <div className="text-xs text-gray-400">Unit price: ₹{unityProduct.price}</div>
              <div className="mt-2 flex items-center gap-2">
                <label className="text-xs">Qty</label>
                <input type="number" className="w-24 rounded bg-gray-800 p-2 text-sm" value={unityQty} onChange={(e) => setUnityQty(Number(e.target.value))} />
                <div className="text-sm font-bold">Total: ₹{(unityProduct.price * unityQty).toFixed(0)}</div>
              </div>

              <div className="mt-3 text-xs text-gray-400">Estimated delivery: {unityProduct.etdDays + 2} days</div>

              {/* Discount calculation - simple example */}
              <div className="mt-3 bg-gray-800 p-3 rounded text-sm">
                <div>Bulk Discount: 10% (applied)</div>
                <div className="font-bold mt-1">Discounted total: ₹{(unityProduct.price * unityQty * 0.9).toFixed(0)}</div>
              </div>

              <div className="mt-4 flex gap-2">
                <button className="flex-1 py-2 rounded bg-amber-500 text-gray-900" onClick={placeUnityOrder}>Place Unity Order</button>
                <button className="flex-1 py-2 rounded border border-gray-800" onClick={() => alert('Contact seller flow - integrate later')}>Contact Seller</button>
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
}